<div class='container content-library__card'>
  <div class='content-library__img-card'>
    <img
      src='https://i.imgur.com/iLiA7oC.png'
      loading='lazy'
      alt='mike'
      class='content-library__image'
    />
  </div>
  <div class='content-library__list'>
    <h2 class='content-library__title'>Ouhh... it's empty in here!</h2>
    <p class='content-library__text'>
      <a class='content-library__link' href='./index.html'>Go back</a>
      and add your favorite movies.
    </p>
  </div>
</div>